import React, { useMemo } from 'react';
import { CellProps } from 'react-table';
import moment from 'moment/moment';

import { useI18n } from 'i18n';
import { ITepLease } from 'types/tep';

export const useTepHistoryColumns = () => {
  const { fc } = useI18n();

  const getDateCell = ({ cell }: CellProps<ITepLease>) => (
    <>{cell.value ? moment(cell.value).format('YYYY-MM-DD') : '-'}</>
  );

  const getPlateNumberCell = ({ row }: CellProps<ITepLease>) => <div>{row.original?.plateNumber || '-'}</div>;

  const getEmailCell = ({ cell }: CellProps<ITepLease>) => <div>{cell.row.original?.email || '-'}</div>;

  const getSinceCell = ({ cell }: CellProps<ITepLease>) => (
    <div>{cell.row.original?.startOn ? moment(cell.row.original.startOn).format('YYYY-MM-DD') : '-'}</div>
  );

  const getUntilCell = ({ cell }: CellProps<ITepLease>) => {
    const endOn = cell.row.original?.endOn;
    const isExpired = endOn && moment(endOn).isBefore(new Date(), 'day');

    return (
      <div style={{ ...(isExpired ? { color: '#C92828' } : {}) }}>
        {endOn ? moment(endOn).format('YYYY-MM-DD') : '-'}
      </div>
    );
  };

  const getTepDurationCell = ({ cell }: CellProps<ITepLease>) => {
    const { startOn, returnedOn, endOn } = cell.row.original || {};

    if (!returnedOn) {
      return <div>-</div>;
    }

    const startDate = moment(startOn);
    const returnDate = moment(returnedOn);
    const durationDays = returnDate.diff(startDate, 'days') + 1;
    const isReturnedAfterEnd = endOn && moment(returnedOn).isAfter(moment(endOn));

    return <div style={{ ...(isReturnedAfterEnd ? { color: '#C92828' } : {}) }}>{`${durationDays} day(s)`}</div>;
  };

  return useMemo(
    () => [
      { Header: fc('ID'), accessor: 'id', width: 70, minWidth: 70 },
      { Header: fc('Device Name'), accessor: 'device.name' },
      {
        Header: fc('Device IMEI'),
        accessor: 'device.imei',
        Cell: ({ cell }: CellProps<ITepLease>) => cell.row.original.device.uri,
        width: 200,
        minWidth: 200,
      },
      {
        Header: fc('Vehicle Plate Number'),
        accessor: 'plateNumber',
        Cell: getPlateNumberCell,
        width: 200,
        minWidth: 200,
      },
      {
        Header: fc('company'),
        accessor: 'company',
        Cell: ({ cell }: CellProps<ITepLease>) => cell.row.original?.company || '-',
      },
      { Header: fc('email'), accessor: 'email', Cell: getEmailCell },
      { Header: fc('Drafted At'), accessor: 'draftedAt', Cell: getDateCell },
      { Header: fc('TEP Start Date'), accessor: 'startOn', Cell: getSinceCell },
      { Header: fc('TEP End Date'), accessor: 'endOn', Cell: getUntilCell },
      { Header: fc('Issued At'), accessor: 'issuedAt', Cell: getDateCell },
      { Header: fc('Returned On'), accessor: 'returnedOn', Cell: getDateCell },
      { Header: fc('TEP Duration'), accessor: 'tepDuration', Cell: getTepDurationCell },
    ],
    [],
  );
};
